import { Modal } from 'antd';
import React from 'react';
import { FinAssetDeprContextResponse } from '../../../../../services/finassets';
import DeprecationScheduleTable from './DeprecationScheduleTable';

type DeprecationScheduleModalProps = {
  onCancel: () => void;
  visible: boolean;
  deprecation?: FinAssetDeprContextResponse;
  currcode?: string;
};

const DeprecationScheduleModal = (props: DeprecationScheduleModalProps) => {
  const { onCancel, visible, deprecation, currcode } = props;

  return (
    <Modal
      style={{ top: 20 }}
      bodyStyle={{ height: '500px' }}
      visible={visible}
      title={
        deprecation?.contextlabel +
        ' - ' +
        deprecation?.methodlabel +
        ' ( ' +
        deprecation?.durationmonths +
        ' M)'
      }
      footer={null}
      onCancel={onCancel}
      width="1300px"
    >
      <DeprecationScheduleTable
        deprecationSchedules={deprecation?.finAssetDeprSchedules}
        currcode={currcode}
      />
    </Modal>
  );
};

export default DeprecationScheduleModal;
